module.exports = __webpack_public_path__ + "static/media/wave-11.150da4b4.svg";